exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-style {\n  border: 1px solid #ccc;\n  text-align: center;\n  margin-left: 5px;\n  width: 100%;\n  height: 70px;\n  border-radius: 10px;\n}\n", ""]);

// exports
